import { platformProps } from "../../lib";
import { Typography } from "../typography";
import type { LabelProps } from "./types";

export const Label = ({
  children,
  required = false,
  disabled = false,
  htmlFor,
  className,
  testID,
  size = "sm",
}: LabelProps) => {
  const resolvedVariant = `label-${size}` as const;

  return (
    <Typography
      {...platformProps({ testID, slot: "label" })}
      variant={resolvedVariant}
      color={disabled ? "neutral-foreground-attenuated" : "neutral-foreground-default"}
      htmlFor={htmlFor}
      className={className}
    >
      {children}
      {required && (
        <Typography variant={resolvedVariant} color="system-danger-default">
          {" *"}
        </Typography>
      )}
    </Typography>
  );
};

Label.displayName = "Label";
